export default function EditColumnsIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="edit-columns"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height * (17.276 / 16.391) : 17.276}
      height={height ? height : width ? width * (16.391 / 17.276) : 16.391}
      viewBox="0 0 17.276 16.391"
    >
      <g
        transform="translate(0.6 0.6)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
      >
        <g transform="translate(8.041 7.125)">
          <path
            d="M37.364,12.433,35,12.858l.394-2.4,5.3-5.288a.788.788,0,0,1,1.119,0l.835.835a.788.788,0,0,1,0,1.119Z"
            transform="translate(-35 -4.942)"
          />
        </g>
        <g opacity={0.7}>
          <path d="M1.433,0H12.664A1.433,1.433,0,0,1,14.1,1.433V4.043H9.41v3.7H4.772v3.94H1.433A1.433,1.433,0,0,1,0,10.245V1.433A1.433,1.433,0,0,1,1.433,0Z" />
          <line y2="3.429" transform="translate(4.88 4.042)" />
          <line x1="9.162" transform="translate(0 4.041)" />
          <line x1="4.658" transform="translate(0 7.635)" />
        </g>
      </g>
    </svg>
  );
}
